<template>
  <post-markup
    class="body-bg-color membership-template-builder"
    :style="[customCss]"
    :activeElement="activeElement"
    :courseSettings="courseSettings"
  >
    <template slot="post-header">
      <post-header :getThemeSettings="getThemeSettings" v-if="isPreview">
        <template slot="logo">
          <header-logo
            v-if="isPreview"
            :logoPath="membershipMasterData.logo"
            :logoSize="membershipMasterData.logo_size"
            :altText="'Header Logo'"
          ></header-logo>
        </template>
        <template slot="menus">
          <menu-items
            :isPreview="isPreview"
            :position="'header'"
            :activeMenus="activeHeaderMenu"
            :sendToPath="sendToPath"
          ></menu-items>
        </template>
        <template slot="profile" v-if="user">
          <header-profile
            :user="user"
            :openProfilePopup="openProfilePopup"
            :logoutUser="logoutUser"
            :isPortal="isPortal"
            :backPortalPage="backPortalPage"
            :profileLabel="membershipMasterData.gen_settings && JSON.parse(membershipMasterData.gen_settings).profile_label"
            :logoutLabel="membershipMasterData.gen_settings &&  JSON.parse(membershipMasterData.gen_settings).logout_label"
          ></header-profile>
        </template>
        <template slot="button" v-else>
          <post-button
            :buttonText="'Log In'"
            :buttonCallback="() => {}"
            :callbackParam="1"
            :specialHover="1"
            :getThemeSettings="getThemeSettings"
          ></post-button>
        </template>
      </post-header>
    </template>
    <template slot="breadcrumb">
      <breadcrumb
        class="membership-layout-container membership-lesson-container lesson-breadcrumb py-5"
        :isPreview="isPreview"
        :hierarchy="hierarchy"
        :activeElement="activeElement"
        :activateElement="activateElement"
        :sendToPath="sendToPath"
        :getThemeSettings="getThemeSettings"
        :courseSettings="courseSettings"
        :getHomeMenuData="getHomeMenuData"
      ></breadcrumb>
    </template>
    <template slot="mark-as-complete">
      <mark-as-complete>
        <template slot="title">
          <span
            v-if="!activeElement.value.is_locked.status"
            class="inter-font-regular"
          >
            {{ activeElement.value.name }}
          </span>
        </template>
        <template slot="button">
          <template-button
            v-if="!activeElement.value.is_locked.status"
            class="w-full blue-button"
            :buttonText="
              activeElement.value.is_completed
                ? 'Completed'
                : courseSettings && courseSettings.gen_settings && courseSettings.gen_settings.markAsCompleteLabel? courseSettings.gen_settings.markAsCompleteLabel:'Mark as complete'
            "
            :buttonCallback="markAsComplete"
            :callbackParam="activeElement.value"
            :specialHover="1"
            :getThemeSettings="getThemeSettings"
          ></template-button>
        </template>
        <template slot="next-or-previous-lesson">
          <course-tile
            :getThemeSettings="getThemeSettings"
            v-if="prevEl || nextEl"
          >
            <template slot="course-tile-image">
              <div
                @click="
                  activateElement({ e: '', el: !nextEl ? prevEl : nextEl })
                "
                class="tile-img cursor-pointer mr-4"
              >
                <img
                  v-if="nextPrevFeaturedImage"
                  class="w-32 h-20 object-cover rounded-lg"
                  :src="nextPrevFeaturedImage"
                />
                <div
                  v-else
                  class="no-image-tile-v2 bg-tile-red text-white text-sm font-bold items-center text-center flex w-32 h-20 rounded-lg justify-center mb-1"
                >
                  {{ !nextEl ? prevEl.name : nextEl.name }}
                </div>
                <!-- <div v-else class="no-image-tile-v2 tile-red text-white text-sm font-bold items-center text-center flex w-full h-20 rounded-lg">SOCIAL MEDIA ADVERTISING</div> -->
              </div>
            </template>
            <template slot="course-tile-title">
              <span
                class="cursor-pointer section-heading-color"
                @click="
                  activateElement({ e: '', el: !nextEl ? prevEl : nextEl })
                "
                >{{ !nextEl ? prevEl.name : nextEl.name }}
              </span>
            </template>
            <template slot="course-tile-description">
              <span
                class="cursor-pointer section-content-color"
                @click="
                  activateElement({ e: '', el: !nextEl ? prevEl : nextEl })
                "
                >{{ !nextEl ? prevEl.description : nextEl.description }}
              </span>
            </template>
            <template slot="course-tile-type">
              <div
                @click="
                  activateElement({ e: '', el: !nextEl ? prevEl : nextEl })
                "
                class="cursor-pointer inter-font-regular w-full h-full flex justify-center items-center"
              >
                <span v-if="courseSettings && courseSettings.gen_settings && courseSettings.gen_settings.viewLessonLabel">{{ courseSettings.gen_settings.viewLessonLabel }}</span>
                <span v-else>View Lesson</span>
              </div>
            </template>
          </course-tile>
        </template>
        <template slot="next-or-previous-buttons">
          <div class="flex justify-between w-full">
            <div
              v-if="prevEl"
              class="text-sm w-1/2 text-left prev-lesson cursor-pointer"
              @click="activateElement({ e: '', el: prevEl })"
            >
              <span class="inline-block align-middle">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                  <path
                    d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
                  />
                </svg>
              </span>
              <span v-if="courseSettings && courseSettings.gen_settings && courseSettings.gen_settings.previousLessonLabel">{{ courseSettings.gen_settings.previousLessonLabel }}</span>
              <span v-else>Previous Lesson</span>
            </div>

            <div
              v-if="nextEl"
              class="text-sm w-full text-right next-lesson cursor-pointer"
              @click="activateElement({ e: '', el: nextEl })"
            >
              <span v-if="courseSettings && courseSettings.gen_settings && courseSettings.gen_settings.nextLessonLabel">{{ courseSettings.gen_settings.nextLessonLabel }}</span>
              <span v-else>Next Lesson</span>
              <span class="inline-block align-middle">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                  <path
                    d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
                  />
                </svg>
              </span>
            </div>
          </div>
        </template>
      </mark-as-complete>
    </template>
    <template slot="post-canvas" v-if="!activeElement.value.is_locked.status">
      <post-canvas
        :isPreview="isPreview"
        :files="files"
        :filesCategory="filesCategory"
        :getThemeSettings="getThemeSettings"
        :getSections="getSections"
        :addNewSection="addNewSection"
        :deleteSection="deleteSection"
        :moveSection="moveSection"
        :cloneSection="cloneSection"
        :updateSectionTitle="updateSectionTitle"
        :updateSectionContent="updateSectionContent"
      ></post-canvas>
    </template>
    <template slot="post-locked" v-else>
      <locked-post
        :isPreview="isPreview"
        :offer="activeElement.value.is_locked.offer"
        :unlockDate="activeElement.value.is_locked.unlock_date"
        :getThemeSettings="getThemeSettings"
      ></locked-post>
    </template>
    <template slot="featured-image">
      <featured-image
        :isPreview="isPreview"
        :src="activeElement.value.featured_image"
        :name="activeElement.value.name"
        :getThemeSettings="getThemeSettings"
        :avatar="activeElement.value.featured_image"
        :businessNiche="'Business'"
        :updateFeaturedImage="updateBannerFeaturedImage"
      ></featured-image>
    </template>
    <template slot="instructor">
      <instructor
        v-if="instructors.length"
        :instructors="instructors"
        :getThemeSettings="getThemeSettings"
      >
      </instructor>
    </template>
    <template slot="progress-bar">
      <progress-bar
        :label="progressBarLabel"
        :completed="completedLessons"
        :total="totalLessons"
        :getThemeSettings="getThemeSettings"
      >
      </progress-bar>
    </template>

    <template slot="hierarchy">
      <hierarchy
        class="shadow-lg"
        :isPreview="isPreview"
        :hierarchy="hierarchy"
        :activeElement="activeElement"
        :activateElement="activateElement"
        :sendToPath="sendToPath"
        :getThemeSettings="getThemeSettings"
        :isOutlineSticky="courseSettings.is_outline_sticky"
        :sidebarType="courseSettings.sidebar_type"
      ></hierarchy>
    </template>
    <template slot="post-footer">
      <post-footer :getThemeSettings="getThemeSettings" v-if="isPreview">
        <template slot="logo">
          <footer-logo
            v-if="isPreview"
            :logoPath="membershipMasterData.footer_logo"
            :altText="'Footer Logo'"
            :logoSize="membershipMasterData.footer_logo_size"
          ></footer-logo>
        </template>
        <template slot="menus">
          <menu-items
            :isPreview="isPreview"
            :position="'footer'"
            :activeMenus="activeFooterMenu"
            :sendToPath="sendToPath"
          ></menu-items>
        </template>
      </post-footer>
    </template>
  </post-markup>
</template>
<script>
import PostMarkup from './post-markup';
import PostHeader from '../../../common/header/header';
import HeaderLogo from '../../../common/header/logo';
import HeaderProfile from '../../../common/header/profile';
import PostCanvas from '../../../common/canvas/canvas';
import LockedPost from '../../../common/lockedPost';
import Breadcrumb from '../../../common/breadcrumb';
import FeaturedImage from '../../../common/featuredImage';
import Instructor from '../../../common/instructor';
import ProgressBar from '../../../common/progressBar';
import Hierarchy from '../../../common/hierarchy';
import PostFooter from '../../../common/footer/footer';
import FooterLogo from '../../../common/footer/logo';
import MenuItems from '../../../common/menuItems';
import MarkAsComplete from '../../../common/mark-as-complete';
import flatTreeHelper from '../../../../../helpers/flatTree';
import CourseTile from '../../../common/tile/tile-v-2';
import TemplateButton from '../../../common/button';

export default {
  name: 'PostTemplate',
  mixins: [],
  components: {
    PostMarkup,
    PostHeader,
    HeaderLogo,
    HeaderProfile,
    PostCanvas,
    LockedPost,
    Breadcrumb,
    FeaturedImage,
    Instructor,
    ProgressBar,
    Hierarchy,
    PostFooter,
    FooterLogo,
    MenuItems,
    MarkAsComplete,
    CourseTile,
    TemplateButton,
  },
  data() {
    return {
      nextPrevFeaturedImage: '',
      outlineLabel: '<h4><strong>Membership Outline</strong></h4>',
    };
  },

  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object,
      default: null,
    },
    openProfilePopup: {
      type: Function,
      default: () => {},
    },
    logoutUser: {
      type: Function,
      default: () => {},
    },
    files: {},
    filesCategory: {},
    instructors: {},
    hierarchy: {},
    activeElement: {},
    activateElement: {
      type: Function,
      default: () => {},
    },
    sendToPath: {
      type: Function,
      default: () => {},
    },
    activeHeaderMenu: {
      type: Array,
      default: () => [],
    },
    activeFooterMenu: {
      type: Array,
      default: () => [],
    },
    getThemeSettings: {},
    addNewSection: {
      type: Function,
      default: () => {},
    },
    deleteSection: {
      type: Function,
      default: () => {},
    },
    moveSection: {
      type: Function,
      default: () => {},
    },
    cloneSection: {
      type: Function,
      default: () => {},
    },
    updateSectionTitle: {
      type: Function,
      default: () => {},
    },
    updateSectionContent: {
      type: Function,
      default: () => {},
    },
    membershipMasterData: {},
    updateBannerFeaturedImage: {
      type: Function,
      default: () => {},
    },
    totalLessons: {
      required: true,
    },
    completedLessons: {
      required: true,
    },
    isPortal: {
      type: Boolean,
      deafult: false,
    },
    backPortalPage: {
      type: Function,
      default: () => {},
    },
    courseSettings: {},
    markAsComplete: {
      type: Function,
      default: () => {},
    },
    totalLessons: {
      required: true,
    },
    completedLessons: {
      required: true,
    },
  },
  computed: {
    getHomeMenuData() {
        return this.activeHeaderMenu.find(item => item.is_default==1);
    },
    loading() {
      if (this.activeElement.value.is_locked.status) {
        return false;
      }
      return !this.activeElement.sectionsLoaded;
    },
    themeSettings() {
      return this.getThemeSettings();
    },
    customCss() {
      return {
        '--template-body-bg-color': this.themeSettings.body_section.bg_color,
        '--template-section-bg-color': this.themeSettings.configuration_options
          .section_bg_color,
      };
    },
    getSections() {
      return () => {
        return this.activeElement.value.sections;
      };
    },
    flatHierarchy() {
      return flatTreeHelper([], this.hierarchy).filter(
        (el) => el.type === 'post'
      );
    },
    nextEl() {
      const index = this.flatHierarchy.findIndex(
        (el) => el.id == this.activeElement.value.id
      );
      const length = this.flatHierarchy.length;

      if (length == index + 1) return null;

      return this.flatHierarchy[index + 1];
    },
    prevEl() {
      const index = this.flatHierarchy.findIndex(
        (el) => el.id == this.activeElement.value.id
      );
      const length = this.flatHierarchy.length;

      if (!index) return null;

      return this.flatHierarchy[index - 1];
    },
    nextPrevEl() {
      return this.nextEl ? this.nextEl : this.prevEl;
    },
    progressBarLabel() {
      return `${this.completedLessons} of ${this.totalLessons} lessons completed`;
    },
  },
  methods: {},
  watch: {
    nextPrevEl: {
      deep: true,
      async handler(newValue, oldValue) {
        if (!newValue) {
          this.nextPrevFeaturedImage = '';
        }

        const bannerType = newValue.configuration_options.hasOwnProperty(
          'banner_type'
        )
          ? newValue.configuration_options.banner_type
          : 'image';

        if (bannerType === 'image') {
          this.nextPrevFeaturedImage = newValue.featured_image;
        } else if (bannerType === 'video') {
          this.nextPrevFeaturedImage = await this.loadThumbnail(
            newValue.featured_video
          );
        } else {
          this.nextPrevFeaturedImage = '';
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.body-bg-color {
  background-color: var(--template-body-bg-color);
}
.section-bg-color {
  background-color: var(--template-section-bg-color);
}
</style>
<style lang="scss">
.membership-layout-container.membership-lesson-container {
  max-width: 1170px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
  .flex > .membership-layout-container {
    padding: 0;
    flex: 1;
  }
  .content.py-5.space-y-2 {
    padding: 20px;
  }
  .membership-content-section {
    padding: 40px 60px;
  }
  .checklist-type-change {
    right: 25px;
    top: 13px;
  }
  .add-section-bottom {
    bottom: auto;
    top: 0;
    margin: 48px 0 0;
  }
}

.next-lesson,
.prev-lesson {
  .inline-block svg {
    width: 10px;
    margin-top: -2px;
  }
}
</style>
